/**
 * Generates the SiQuote API URLs based on the provided base URI.
 * This function is used by all environment files to maintain a single source of truth
 * for API endpoint paths.
 */
export function createSiQuoteUrls(apiBaseURI: string) {
    return {
        loginService: apiBaseURI + '/solapi/LoginOperation/',
        costReview: apiBaseURI + '/solapi/CostReview',
        estimateSearch: apiBaseURI + '/solapi/EstimateSearch',
        estimateOperations: apiBaseURI + '/solapi/EstimateOperations',
        metaData: apiBaseURI + '/solapi/MetaData',
        projectOperation: apiBaseURI + '/solapi/ProjectOperation',
        reports: apiBaseURI + '/solapi/Report',
        collaboration: apiBaseURI + '/solapi/Collaboration',
        userPreferences: apiBaseURI + '/solapi/UserPreferences',
        materialChecker: apiBaseURI + '/solapi/MaterialChecker',
        productPromotion: apiBaseURI + '/solapi/ProductPromotion',
        crm: apiBaseURI + '/solapi/CRM',
        userData: apiBaseURI + '/solapi/UserData',
        proposal: apiBaseURI + '/solapi/Proposal',
        synchronization: apiBaseURI + '/solapi/Synchronization',
        notification: apiBaseURI + '/solapi/Notification',
        sapSubmittal: apiBaseURI + '/solapi/SapSubmittal'
    };
}

export type SiQuoteUrls = ReturnType<typeof createSiQuoteUrls>;
